/* Unforgettable Box theme: mobile menu, shake-the-box hints, plan selection with live totals, gift note, address delete. */
(function () {
  'use strict';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* Mobile menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    var setMenu = function (open) {
      menu.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Close' : 'Menu';
    };
    toggle.addEventListener('click', function () {
      setMenu(!menu.classList.contains('is-open'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        setMenu(false);
        toggle.focus();
      }
    });
    each(menu.querySelectorAll('a'), function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
  }

  /* Shake the box (hero) */
  var fig = document.querySelector('[data-box-figure]');
  var shake = document.querySelector('[data-shake]');
  var out = document.querySelector('[data-rattle-text]');
  var hintList = document.querySelector('[data-hints]');
  if (fig && shake && out) {
    var hints = hintList
      ? Array.prototype.map.call(hintList.children, function (li) { return li.textContent.trim(); }).filter(Boolean)
      : [];
    var hi = 0;
    shake.addEventListener('click', function () {
      fig.classList.remove('shake');
      void fig.offsetWidth;
      fig.classList.add('shake');
      if (hints.length) {
        out.textContent = hints[hi % hints.length];
        hi += 1;
      }
    });
    fig.addEventListener('animationend', function () { fig.classList.remove('shake'); });
  }

  /* Product form: plan choice, live totals and gift note */
  each(document.querySelectorAll('[data-product-form]'), function (form) {
    var radios = form.querySelectorAll('input[name="plan_choice"]');
    var spInput = form.querySelector('[data-selling-plan-input]');
    var priceEls = document.querySelectorAll('[data-price-now]');
    var currency = form.getAttribute('data-currency') || 'USD';
    var ship = parseInt(form.getAttribute('data-ship-cents') || '0', 10) || 0;

    function fmt(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (err) {
        return (cents / 100).toFixed(2);
      }
    }
    function setText(selector, text) {
      each(form.querySelectorAll(selector), function (el) { el.textContent = text; });
    }

    function syncPlan() {
      var checked = form.querySelector('input[name="plan_choice"]:checked');
      if (!checked) { return; }

      var planId = checked.getAttribute('data-selling-plan') || '';
      if (spInput) {
        spInput.value = planId;
        spInput.disabled = !planId;
      }

      var price = checked.getAttribute('data-price');
      if (price) {
        each(priceEls, function (el) { el.textContent = price; });
      }
      var label = checked.getAttribute('data-label');
      if (label) {
        setText('[data-plan-label]', label);
      }

      var cents = parseInt(checked.getAttribute('data-cents') || '', 10);
      var boxes = parseInt(checked.getAttribute('data-boxes') || '1', 10);
      if (isNaN(boxes)) { boxes = 1; }
      if (!isNaN(cents) && ship > 0) {
        var n = boxes > 0 ? boxes : 1;
        setText('[data-sum-items-label]', boxes > 0 ? n + (n === 1 ? ' box' : ' boxes') + ' at ' + fmt(cents) : 'Each box');
        setText('[data-sum-items]', fmt(cents * n));
        setText('[data-sum-ship-label]', 'Shipping, ' + n + ' x ' + fmt(ship));
        setText('[data-sum-ship]', fmt(ship * n));
        setText('[data-sum-total]', fmt((cents + ship) * n));
        setText('[data-total-label]', boxes === 0 ? 'Per delivery' : (n === 1 ? 'Total' : 'Estimated total'));
        setText('[data-sum-per]', fmt(cents + ship) + ' per box with shipping');
      }
    }
    each(radios, function (r) { r.addEventListener('change', syncPlan); });
    syncPlan();

    var giftToggle = form.querySelector('[data-gift-toggle]');
    var giftWrap = form.querySelector('[data-gift-wrap]');
    var giftNote = form.querySelector('[data-gift-note]');
    if (giftToggle && giftWrap && giftNote) {
      giftToggle.addEventListener('change', function () {
        giftWrap.hidden = !giftToggle.checked;
        giftNote.disabled = !giftToggle.checked;
        if (giftToggle.checked) { giftNote.focus(); }
      });
    }
  });

  /* Delete a saved address (needs Shopify's shopify_common.js, loaded on the addresses page) */
  each(document.querySelectorAll('[data-address-delete]'), function (btn) {
    btn.addEventListener('click', function () {
      if (!window.Shopify || !window.Shopify.postLink) { return; }
      if (window.confirm('Delete this address?')) {
        window.Shopify.postLink(btn.getAttribute('data-address-delete'), { parameters: { _method: 'delete' } });
      }
    });
  });
})();
